import React, { useState, ChangeEvent, useCallback, FormEvent, useEffect } from 'react';
import SiteWrapper from "../../base/SiteWrapper";
import { useHistory, useParams } from 'react-router-dom';
import {
  Page,
  Button,
  Form,
  Card
} from "tabler-react";

import Recovery from '../../interfaces/Recovery';
import { useAuth } from '../../hooks/AuthContext';
import { ApiFidegg } from "../../services/apiFideggAdmin";
import { Alerta } from "../../utils/Alerta";
import Params from "../../interfaces/Params";

interface RegenerateCouponResponse {
  id: string;
  codigo: string;
}

function RegenerateCouponForm() {

  const history = useHistory();
  const { store } = useAuth();

  const { id } = useParams<Params>();

  const [recovery, setRecovery] = useState<Recovery>({} as Recovery);
  const [value, setValue] = useState(0);

  useEffect(() => {
    (async () => {
      if(!!id) {
        if(store?.program_type === 1) {
          const recoveries = await ApiFidegg.get(`recoveries/${id}`);
          if (recoveries) {
            setRecovery(recoveries.data);
            setValue(recoveries.data.recoveryTypeStore.options.value);
          }
        } else {
          const cashbackRecoveries = await ApiFidegg.get(`cashbackrecoveries/${id}`);
          if (cashbackRecoveries.status === 200) {
            setRecovery(cashbackRecoveries.data);
            setValue(cashbackRecoveries.data.value);
          }
        }
      }
    })();
  }, [id, store]);

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      try {
        event.preventDefault();

        const data = {
          "recovery_id": recovery.id,
          "value": value,
        }

        const response = await ApiFidegg.post('regeneratecoupon', data)
        const responseData = response.data as RegenerateCouponResponse;
        Alerta(`Cupom gerado novamente! Novo código: ${responseData.codigo}`, 'success');

        const pushRoute = (store?.program_type == 1) ? '/recoveries' : '/cashbackrecoveries'
        history.push(pushRoute);
      } catch (err) {
        Alerta('Erro ao gerar cupom novamente!');
      }
    }, [history, recovery.id, store, value]
  );

  function handleClickCancel(event: FormEvent) {
    event.preventDefault();
    history.goBack();
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setValue(value ? parseFloat(value) : 0);
  }

  return (
    <SiteWrapper>
      <Form onSubmit={handleSubmit}>
        <Page.Card
          title="Gerar novo Cupom"
          footer={
            <Card.Footer>
              <div className="d-flex">
                <Button link onClick={handleClickCancel} >Cancelar</Button>
                <Button type="submit" color="primary" className="ml-auto">
                  Gerar
                </Button>
              </div>
            </Card.Footer>
          }
        >
          <Form.FieldSet>
            <Form.Group label="Valor">
              <Form.Input
                name="value"
                value={value}
                onChange={handleChange}
              />
            </Form.Group>
          </Form.FieldSet>
        </Page.Card>
      </Form>
    </SiteWrapper>
  );
}

export default RegenerateCouponForm;